import React from 'react';

import InformationModal from './InformationModal';
import { useGetLocalization } from '../../hooks';

/**
 * Factory function that creates information modal components from configuration
 * @param {Object} config - Modal configuration
 * @param {string} config.titleKey - Localization key for modal title
 * @param {Array} config.informationList - Array of {item, definition} localization keys
 * @param {string} config.iconId - DOM element ID for the icon button
 * @param {string} [config.wrapperClassName] - Optional CSS class for wrapper div
 * @returns {Function} React component
 */
const createInformationModal = (config) => {
  function InformationModalComponent() {
    const getLocalization = useGetLocalization();

    // Localize all strings before passing to InformationModal
    const localizedInformationList = config.informationList.map(({ item, definition }) => ({
      item: item ? getLocalization(item) : undefined,
      definition: getLocalization(definition),
    }));

    const content = (
      <InformationModal
        modalTitle={getLocalization(config.titleKey)}
        informationList={localizedInformationList}
        iconId={config.iconId}
      />
    );

    // If wrapper class is specified, wrap the modal
    if (config.wrapperClassName) {
      return <div className={config.wrapperClassName}>{content}</div>;
    }

    return content;
  }

  // Set display name for better debugging
  InformationModalComponent.displayName = `InformationModal(${config.iconId})`;

  return InformationModalComponent;
};

export default createInformationModal;
